import {FormattedMessage} from "react-intl";
import RadioButtonGroup from "../../RadioButtonGroup/RadioButtonGroup";
import React from "react";
import {Link} from "react-router-dom";

let copperWeight = [
    {id: 1, checked: true, text: ("35 μm") , name: "copperWeight", disabled:false},
    {id: 2, checked: false, text: "70 μm", name: "copperWeight", disabled:false},
];

let copperWeightThickness = [
    {id: 1, checked: true, text: ("35 μm") , name: "copperWeight", disabled:false},
    {id: 2, checked: false, text: "70 μm", name: "copperWeight", disabled:true},
];

const CopperWeight = (props) => {
    let layer = props.pcbParams.layer;
    let thickness = props.pcbParams.thickness;
    let thicknesses = [0.4, 0.6, 0.8, 1.0, 1.2, 1.6, 2.0];
    let enabledThicknesses = [1.6, 2.0];
    let pcbCopperWeight = copperWeight.map((item) => {

        //
        // if(thickness < 1.6 && item.id === 2){
        //     item.disabled = true;
        //     item.checked = false;
        // }else{
        //     item.disabled = false;
        // }
        // item.checked = (item.id === props.selectedId);

        // console.log("COPPER WEIGHT SELECTED ID ====> ",props.selectedId);

        if (thickness < 1.6 && item.id === 2) {
            // console.log("THICKNESS LESS ==========> ", thickness);
            item.disabled = item.id === 2;
            item.id === 2 ? item.checked = false : item.checked = true;
        } else {
            item.disabled = false;
        }

        if(item.id === 2 && thickness < 1.6){
            if(layer === 1){
                item.disabled = true;
            }
            else{
                let selected = thicknesses.filter(n=> !enabledThicknesses.includes(n));
                item.disabled = selected.includes(thickness);
            }
        }
        return item;
    });

    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div space-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-copper-weight"
                                          defaultMessage="Copper Weight"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <Link id="copper-qLink"
                            to={{pathname:"https://kitcutlabo.com/copper-thickness/"}} target="_self"
                            className="glyphicon glyphicon-question-sign question-link"></Link>

                    </div>
                    <div className="btn-group col-md-9 pcb-details-div-items ">
                        {props.pcbParams.thickness < 1.6 ?
                            <RadioButtonGroup data={copperWeightThickness} getParams={props.setPCBParams}/>
                            :
                            ""
                        }
                        {props.pcbParams.thickness >= 1.6 ?
                            <RadioButtonGroup data={pcbCopperWeight} getParams={props.setPCBParams}/>
                            :
                            ""
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CopperWeight;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/CopperWeight.js